// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './Homepage.js';  // Changed to match exact filename
import ImporterExtension from './ImporterExtension.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/importer-extension" element={<ImporterExtension />} />
      </Routes>
    </Router>
  );
}

export default App;